import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider as JotaiProvider } from 'jotai';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { ToastProvider } from 'app/components/app/toast/toast';
import { PopupProvider } from 'app/components/utils/popup';
import { PublicSearchV1 } from 'app/pages/search/public/v1/searches.v1';

/**
 * The Search application
 */
export const SearchApplication: React.FC = () => {
  return <PublicSearchV1 />;
};

/**
 * Initiate query client
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      gcTime: 1000,
      staleTime: Infinity
    }
  }
});

/**
 * Start the application
 */
export const startSearchApplication = () => {
  const root = ReactDOM.createRoot(
    document.getElementById('search-application-root') as HTMLDivElement
  );

  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <JotaiProvider>
          <ToastProvider>
            <PopupProvider>
              <SearchApplication />
            </PopupProvider>
          </ToastProvider>
        </JotaiProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
};
